import React, { Component } from "react";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Colors from "../../common/Colors";
import Toast from "../../components/Toast";
import routes from "../../routes/URL"
import moment from "moment"
import { endsWith } from "lodash";

// Move PLAN_FEATURES outside of render method
// const PLAN_FEATURES = {
//   "etable mini": [
//     { name:  "Cloud-Based POS", },
//     { name:"Order Tracking", },
//     { name:  "Pick-Up Orders", },
//     { name: "Order History", },
//     { name: "Manage Tips", },
//     { name: "Discounts & Coupons", },
//     { name: "Variations & Add-Ons", },
//     { name: "Time-Slot Wise Menu", },
//     { name:  "Space-Wise Menu Pricing", },
//     { name: "Digital QR-Based Menu", },
//     { name:  "Thermal Print Support",},
//     { name:   "Cart Sharing", },
//     { name:  "Digital Token for Queue Mgt.", },
//     { name: "User Feedback Collection", },
//     { name: "Google Reviews Integration", },
//     { name: "Multi-Language Support", },
//     { name: "SMS & Notification Alerts", },
//     { name:  "Real-Time Order Status", },
//     { name: "Table & Space Management", },
//     { name:  "Table & Hall Bookings", },
//     { name:  "Change / Merge / Split Table", },
//     { name: "Third-Party Integrations ", },
//     { name: "Payment Gateway Integrations", },
//     { name: "Real-Time Dashboard & Reports", },
//     { name: "Customer List (CRM)" ,},
//     { name:  "iOS, Android & Web Applications", },
//     { name:  "Daily Cloud Backup",},
//     { name:"Special Menu Banner", },
//     { name: "24/7 Customer Support", }



//   ],
//   "etable pro": [
//     { name:  "Cloud-Based POS", },
//     { name:"Order Tracking", },
//     { name:  "Pick-Up Orders", },
//     { name: "Order History", },
//     { name: "Manage Tips", },
//     { name: "Discounts & Coupons", },
//     { name: "Variations & Add-Ons", },
//     { name: "Time-Slot Wise Menu", },
//     { name:  "Space-Wise Menu Pricing", },
//     { name: "Digital QR-Based Menu", },
//     { name:  "Thermal Print Support",},
//     { name:   "Cart Sharing", },
//     { name:  "Digital Token for Queue Mgt.", },
//     { name: "User Feedback Collection", },
//     { name: "Google Reviews Integration", },
//     { name: "Multi-Language Support", },
//     { name: "SMS & Notification Alerts", },
//     { name:  "Real-Time Order Status", },
//     { name: "Table & Space Management", },
//     { name:  "Table & Hall Bookings", },
//     { name:  "Change / Merge / Split Table", },
//     { name: "Third-Party Integrations ", },
//     { name: "Payment Gateway Integrations", },
//     { name: "Real-Time Dashboard & Reports", },
//     { name: "Customer List (CRM)" ,},
//     { name:  "iOS, Android & Web Applications", },
//     { name:  "Daily Cloud Backup",},
//     { name:"Special Menu Banner", },
//     { name: "24/7 Customer Support", },
//     { name:  "Call the Waiter Feature" },
//     { name:"KOT & KDS with Print", },
//     { name:  "Employee Management",},
//     { name:  "Inventory Management", },
//     { name: "Staff Login with few Permissions" },
//   ],
//   "etable max": [
//         { name:  "Cloud-Based POS", },
//     { name:"Order Tracking", },
//     { name:  "Pick-Up Orders", },
//     { name: "Order History", },
//     { name: "Manage Tips", },
//     { name: "Discounts & Coupons", },
//     { name: "Variations & Add-Ons", },
//     { name: "Time-Slot Wise Menu", },
//     { name:  "Space-Wise Menu Pricing", },
//     { name: "Digital QR-Based Menu", },
//     { name:  "Thermal Print Support",},
//     { name:   "Cart Sharing", },
//     { name:  "Digital Token for Queue Mgt.", },
//     { name: "User Feedback Collection", },
//     { name: "Google Reviews Integration", },
//     { name: "Multi-Language Support", },
//     { name: "SMS & Notification Alerts", },
//     { name:  "Real-Time Order Status", },
//     { name: "Table & Space Management", },
//     { name:  "Table & Hall Bookings", },
//     { name:  "Change / Merge / Split Table", },
//     { name: "Third-Party Integrations ", },
//     { name: "Payment Gateway Integrations", },
//     { name: "Real-Time Dashboard & Reports", },
//     { name: "Customer List (CRM)" ,},
//     { name:  "iOS, Android & Web Applications", },
//     { name:  "Daily Cloud Backup",},
//     { name:"Special Menu Banner", },
//     { name: "24/7 Customer Support", },
//     { name:  "Call the Waiter Feature" },
//     { name:"KOT & KDS with Print", },
//     { name:  "Employee Management",},
//     { name:  "Inventory Management", },
//     { name: "Staff Login with few Permissions" },
//     { name: "Hotel In-Room Service" },
//     { name: "Hotel Room Booking" },
//     { name: "Manage Up to 3 Branches" },
//   ]
// };

class ListHotelScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      currentPlan: null,
      isPlanActive: false,
      toast: {
        open: false,
        message: "",
        severity: "success"
      },
      daysRemaining: null,
      endDate: null
    };
  }

  componentDidMount() {
    this.getData();

    this.loadCashfreeSdk();
  }

  loadCashfreeSdk = () => {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/ui/2.0.0/cashfree.sandbox.js";
    script.async = true;
    document.body.appendChild(script);
  };

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  // getFeaturesByPlanName = (planName) => {
  //   const normalizedPlanName = planName.toLowerCase();
  //   return PLAN_FEATURES[normalizedPlanName] || [];
  // };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  paid = async (data) => {
    try {
      const fd = {
        custom: true,
        orderId: data.order?.orderId,
        status: data.order?.status,
        gateway: 'cashfree'
      };

      const response = await API(this, "post", URL_PATH.paymentDone, fd);
      const { status, message } = response;

      if (status === "success") {
        window.location.replace("/");
        this.props.setSubscriptionActive(true);
        this.showToast("Payment processed successfully");
      } else {
        this.showToast(message || "Payment verification failed", "error");
      }
    } catch (error) {
      console.error("Payment processing error:", error);
      this.showToast("There was an error processing your payment", "error");
    }
  };

  subscribe = async (item, action) => {
    try {
      let api = "";
      let fd = {};

      switch (action) {
        case "subscribe":
          api = URL_PATH.subscribeToPlan;
          fd = {
            plan_id: item.id,
            type: "subscribe",
            payment_gateway: item.id === 4 ? "free" : "cashfree"
          };
          break;
        case "renew":
          api = URL_PATH.upgradePlan;
          fd = {
            plan_id: item.id,
            type: "renew",
            payment_gateway: "cashfree"
          };
          break;
        case "upgrade":
          api = URL_PATH.upgradePlan;
          fd = {
            plan_id: item.id,
            type: "upgrade",
            payment_gateway: "cashfree"
          };
          break;
        default:
          return;
      }

      const response = await API(this, "post", api, fd);
      console.log("Payment Response:", response);

      if (response.status !== "success") {
        return this.showToast(response.message || "Payment initiation failed", "error");
      }

      // Call Cashfree payment ONLY if payment_gateway is cashfree
      if (fd.payment_gateway === "cashfree") {
        this.processCashfreePayment(response);
      } else {
        // Handle success for free plan directly
        this.showToast("You have successfully subscribed to the free plan!", "success");
        // Add null check for history
        if (this.props.history) {
          this.props.history.push(routes.admin.hotels.create);
        }
      }

    } catch (error) {
      console.error("Payment error:", error);
      this.showToast("There was an error initiating your payment", "error");
    }
  };

  processCashfreePayment = (response) => {
    try {
      const { payment_session_id } = response.data;

      if (!payment_session_id) {
        return this.showToast("Invalid Cashfree payment session data", "error");
      }

      if (window.Cashfree) {
        const paymentContainer = document.getElementById("payment-container");
        if (paymentContainer) {
          paymentContainer.style.display = 'flex';
          paymentContainer.innerHTML = '';

          // Create a smaller inner container for the payment form
          const innerContainer = document.createElement('div');
          innerContainer.style.position = 'relative';
          innerContainer.style.width = '450px';
          innerContainer.style.maxWidth = '90%';
          innerContainer.style.backgroundColor = 'white';
          innerContainer.style.borderRadius = '8px';
          innerContainer.style.padding = '20px';
          innerContainer.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';

          // Add close button
          const closeButton = document.createElement('button');
          closeButton.innerHTML = '×';
          closeButton.style.position = 'absolute';
          closeButton.style.top = '10px';
          closeButton.style.right = '10px';
          closeButton.style.background = 'none';
          closeButton.style.border = 'none';
          closeButton.style.color = '#333';
          closeButton.style.fontSize = '24px';
          closeButton.style.cursor = 'pointer';
          closeButton.onclick = () => {
            paymentContainer.style.display = 'none';
            paymentContainer.innerHTML = '';
          };
          innerContainer.appendChild(closeButton);

          // Add payment form container
          const formContainer = document.createElement('div');
          formContainer.id = 'cashfree-form';
          formContainer.style.marginTop = '20px';
          innerContainer.appendChild(formContainer);

          paymentContainer.appendChild(innerContainer);
        }

        const cashfree = new window.Cashfree(payment_session_id);

        const dropinConfig = {
          components: ["order-details", "card", "netbanking", "app", "upi"],
          onSuccess: (data) => {
            console.log("Cashfree success:", data);
            const paymentContainer = document.getElementById("payment-container");
            if (paymentContainer) {
              paymentContainer.style.display = 'none';
            }

            if (data.order && data.order.status === "PAID") {
              this.paid(data);
            } else {
              this.showToast("Payment is not confirmed yet. Please wait for confirmation.", "warning");
            }
          },
          onFailure: (data) => {
            console.log("Cashfree failure:", data);
            const paymentContainer = document.getElementById("payment-container");
            if (paymentContainer) {
              paymentContainer.style.display = 'none';
            }
            this.showToast("Payment failed. Please try again.", "error");
          },
          style: {
            backgroundColor: "#f9f9f9",
            color: "#11385b",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            errorColor: "#ff0000",
            theme: "light",
          },
        };

        cashfree.drop(document.getElementById("cashfree-form"), dropinConfig);
      } else {
        console.error("Cashfree SDK not loaded");
        this.showToast("Failed to initialize payment", "error");
      }
    } catch (error) {
      console.error("Cashfree payment error:", error);
      this.showToast("Failed to initialize payment", "error");
    }
  };

  getData = async () => {
    try {
      const response = await API(this, "get", URL_PATH.subscriptionPlans);
      const { status, data, message, currentPlan = null, isPlanActive } = response;

      if (status === "success") {
        let daysRemaining = null;
        let endDate = null;

        if (currentPlan) {
          endDate = currentPlan.ends_at || currentPlan.trial_ends_at;
          if (endDate) {
            daysRemaining = moment(endDate).diff(moment(), "days");
          }
        }
console.log("responsessss",response)
        this.setState({
          status,
          data: data || [],
          message,
          currentPlan,
          isPlanActive,
          daysRemaining,
          endDate
        });
      } else {
        this.showToast(message || "Failed to load subscription plans", "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.showToast("Error loading subscription plans", "error");
    }
  };

  renderPlanStatus = () => {
    const { currentPlan, daysRemaining, endDate } = this.state;

    if (!currentPlan || daysRemaining === null || !endDate) {
      return null;
    }

    const isTrial = currentPlan.plan_id === 4;
    const formattedEndDate = moment(endDate).format("MMMM Do, YYYY");

    return (
      <div style={{
        textAlign: "center",
        margin: "40px 0",
        padding: "20px",
        backgroundColor: "#041A29",
        borderRadius: "8px",
        border: `1px solid ${Colors.primary}`,
        maxWidth: "600px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
        <h3 style={{
          color: Colors.primary,
          marginBottom: "10px",
          fontSize: "20px"
        }}>
        </h3>
        <p style={{ color: "white", marginBottom: "5px" }}>
          {isTrial ? "Trial" : "Plan"} ends on: {formattedEndDate}
        </p>
        <p style={{ color: "white", fontWeight: "bold" }}>
          {daysRemaining > 0
            ? `${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} remaining`
            : "Your plan has expired"}
        </p>
      </div>
    );
  };

  renderButton = (item) => {
    const { currentPlan, isPlanActive } = this.state;

    // If there's an active plan, hide the Free Trial button
    if (item.price === 0 && currentPlan && isPlanActive.status === true) {
      return null;
    }

    let buttonText = "Subscribe";
    let action = "subscribe";

    if (item.price === 0) {
      buttonText = "Take 7 Days Free Trial";
      action = "subscribe";
    }
    else if (!currentPlan) {
      buttonText = "Subscribe Now";
      action = "subscribe";
    } else if (currentPlan.plan.id === item.id) {
      if (isPlanActive.status === false) {
        buttonText = "Renew Now";
        action = "renew";
      } else {
        buttonText = "Active";
        action = "";
      }
    } else {
      buttonText = "Upgrade";
      action = "upgrade";
    }

    if (currentPlan && currentPlan.plan.id > item.id) return null;

    return (
      <button
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "6px 15px",
          borderRadius: "30px",
          fontWeight: "600",
          fontSize: "14px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          border: "none",
          outline: "none",
          position: "relative",
          overflow: "hidden",
          backgroundColor: item.tier === 1 ? Colors.primary : "#00A651",
          color: item.tier === 1 ? "black" : "white",
          boxShadow: item.tier === 1 ? "0 4px 15px rgba(250, 172, 64, 0.3)" : "0 4px 15px rgba(76, 175, 80, 0.3)",
          ...(!action ? {
            backgroundColor: "#00A651",
            color: "white",
            cursor: "not-allowed",
            boxShadow: "none"
          } : {})
        }}
        onClick={() => {
          if (action) this.subscribe(item, action);
        }}
        disabled={!action}
      >
        {buttonText}
        {item.tier === 1 && (
          <span style={{ marginLeft: "8px", transition: "transform 0.3s ease" }}>→</span>
        )}
      </button>
    );
  };





  renderFreePlanButton = () => {
    const freePlan = this.state.data.find(plan => plan.price === 0);
    if (!freePlan) return null;

    return (
      <div style={{
        textAlign: "center",
        marginTop: "20px",
        padding: "15px",
        backgroundColor: "#041A29",
        borderRadius: "8px",
      }}>
        {this.renderButton(freePlan)}
      </div>
    );
  };

  render() {
    const { data } = this.state;

    // Add loading state check
    if (!data || data.length === 0) {
      return (
        <div style={{
          backgroundColor: "#02111B",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white"
        }}>

        </div>
      );
    }

    const popularPlan = data.find(plan => plan.tier === 1);

    return (
      <div style={{
        backgroundColor: "#02111B",
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        color: "#333",
        padding: "60px 0"
      }}>
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        {/* Payment Container Overlay */}
        <div id="payment-container" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}></div>

        <div style={{
          maxWidth: "1500px",
          margin: "0 auto",
          padding: "0 20px"
        }}>
          {/* Header */}
          <div style={{
            textAlign: "center",
            marginBottom: "60px"
          }}>
            <h1 style={{
              fontSize: "42px",
              fontWeight: "700",
              color: Colors.primary,
              margin: "0 0 15px 0",
              textTransform: "uppercase",
              letterSpacing: "1px"
            }}>
              Choose Your Plan
            </h1>
            <div style={{
              width: "80px",
              height: "4px",
              background: `linear-gradient(90deg, ${Colors.primary}, #ff9a44)`,
              margin: "0 auto 20px",
              borderRadius: "2px"
            }}></div>
            <p style={{
              fontSize: "18px",
              color: "white",
              maxWidth: "600px",
              margin: "0 auto",
              lineHeight: "1.6"
            }}>
              Select the perfect plan for your restaurant needs
            </p>
          </div>



          {/* Plans */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "30px",
            margin: "0 -15px"
          }}>
           {data.filter(plan => plan.price > 0).map((item, index) => {
  const isPopular = item.tier === 1;
  const isMaxPlan =item.id === 3;

  return (
    <div
      key={index}
      style={{
        position: "relative",
        transition: "all 0.3s ease",
        borderRadius: "12px",
        backgroundColor: "#041A29",
        display: "flex",
        flexDirection: "column",
        ...(isPopular ? {
          transform: "translateY(-10px)",
          boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
          border: `2px solid ${Colors.primary}`
        } : {}),
        ...(item.price === 0 ? {
          border: "2px solid #4CAF50"
        } : {})
      }}
    >
      {isPopular && (
        <div style={{
          position: "absolute",
          top: "0",
          left: "50%",
          transform: "translateX(-50%)",
          background: Colors.primary,
          color: "black",
          padding: "6px 20px",
          borderRadius: "20px ",
          fontWeight: "600",
          fontSize: "12px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          zIndex: "2",
          lineHeight: "1.2",
          marginTop: "-13px"
        }}>
          MOST POPULAR
        </div>
      )}

      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "30px"
      }}>
        <div style={{
          textAlign: "center",
          borderBottom: "1px solid #eee",
          paddingBottom: "25px",
          marginBottom: "25px"
        }}>
          <h3 style={{
            fontSize: "24px",
            fontWeight: "700",
            margin: "0 0 10px 0",
            color: "white",
            ...(isPopular ? { color: Colors.primary } : {}),
            ...(item.price === 0 ? { color: "#4CAF50" } : {})
          }}>
            {item.name}
          </h3>
          <p style={{
            fontSize: "14px",
            color: "white",
            margin: "0 0 20px 0",
            lineHeight: "1.5"
          }}>
            {item.description}
          </p>

          <div style={{ margin: "25px 0" }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px"
            }}>
              <div style={{ textAlign: "center" }}>
                <div style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "center"
                }}>
                  <span style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "white",
                    marginRight: "5px",
                    lineHeight: "1",
                    ...(isPopular ? { color: Colors.primary } : {}),
                    ...(item.monthly_price === 0 ? { color: "#4CAF50" } : {})
                  }}>
                    {item.monthly_price > 0 ? '₹' : ''}
                  </span>
                  <span style={{
                    fontSize: "48px",
                    fontWeight: "800",
                    lineHeight: "1",
                    color: "white",
                    ...(isPopular ? { color: Colors.primary } : {}),
                    ...(item.monthly_price === 0 ? { color: "#4CAF50" } : {})
                  }}>
                    {item.price === 0 ? "FREE" : ( item.price).toLocaleString('en-IN')}
                  </span>
                </div>
              </div>
            </div>

            <p style={{
              fontSize: "14px",
              color: "white",
              margin: "5px 0 0 0"
            }}>
              {item.price > 0 ? 
                (isMaxPlan ? "PER RESTRO UPTO 3 BRANCHES / PER YEAR" : "PER RESTRO / PER YEAR") 
                : "for 7 days"}
            </p>
          
          </div>

          <div style={{
            textAlign: "center"
          }}>
            {this.renderButton(item)}
          </div>
        </div>

        <div style={{
          flexGrow: "1",
          marginBottom: "25px"
        }}>
          <ul style={{
            listStyle: "none",
            padding: "0",
            margin: "0"
          }}>
            {item.features.map((feature, featureIndex) => (
              <li key={featureIndex} style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
                color: "#555",
                fontSize: "15px",
                lineHeight: "1.4"
              }}>
                <span style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  background: isPopular ? Colors.primary : "#4CAF50",
                  marginRight: "12px",
                  fontSize: "12px",
                  color: isPopular ? "black" : "white",
                  flexShrink: "0"
                }}>
                  ✓
                </span>
                <span style={{ color: "white" }}>{feature.name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {isPopular && this.renderFreePlanButton()}
    </div>
  );
})}
          </div>
          {this.renderPlanStatus()}


        </div>

      </div>
    );
  }
}

export default redux(ListHotelScreen);